import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9968 1.6582L22.4127 10.9168L21.084 12.4116L20.0009 11.4489V21.9998H15.5V15H8.5V21.9998H4.00092V11.4536L2.90685 12.4109L1.58984 10.9058L6.00092 7.04607V2.99984H8.00092V5.25448L11.9968 1.6582Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 22V17H13.5V22H10.5Z"}}]};

const HousesFilled = Vue.extend<IconProps>({
  name: 'HousesFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'houses-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default HousesFilled;
